module.exports = __webpack_public_path__ + "images/2i54e30d9621d2fe192789584f36d10b3f.svg";